import type { AdminLoginAnswer } from '@/features/auth/types/AdminLoginAnswer';
import { apiGet, apiPost } from '@/services/api';

/**
 * The administration's password sign-in (ADM-1). Both writes are CSRF-protected like the rest of
 * the API, and a signed-out tab has no XSRF-TOKEN cookie yet: reading /api/v1/me first — a 401
 * that sets it — is what lets the login be sent at all.
 */
export const adminAuthApi = {
  login: async (username: string, password: string) => {
    await apiGet('/api/v1/me').catch(() => undefined);
    return apiPost<AdminLoginAnswer>('/api/v1/admin/auth/login', { username, password });
  },
  changePassword: (currentPassword: string, newPassword: string) =>
    apiPost('/api/v1/admin/auth/password', { currentPassword, newPassword }),
};
